import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './assets/scss/element-variables.scss'
import './assets/scss/styles.scss'
import SilkPopup from './components/SilkPopup'
import util from './util'

Vue.config.productionTip = false
Vue.component('SilkPopup', SilkPopup)

/*
* @method { filter } 格式化货币
* @param { Number } number 货币值
* @param { String } symbol 货币符号
* @param { Number } places 保留小数位数
* @param { String } thousand 千分位符号
* @param { String } decimal 小数点符号
* @param { Boolean } position 货币符号位置前置
* */

function formatMoney(number = 0, symbol = '$', places = 2, thousand = ',', decimal = '.', position = true) {
  if (typeof number === "string") {
    number = number.replace(',', '').match(/(\d+(\.\d+)?)/g);
  }
  const negative = number < 0 ? "-" : "";
  const i = parseInt(Math.abs(number).toFixed(places)) + "";
  const j = i.length > 3 ? i.length % 3 : 0;
  const sumber = negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(Math.abs(number) - i).toFixed(places).slice(2) : "");
  return position ? symbol + sumber : sumber + symbol
}

Vue.mixin({
  data() {
    return {
      that: this
    }
  },
  filters: {
    formatMoney,
    dateFormat(date, vm) {
      if (date) {
        let lang = vm.$i18n.locale
        const langMap = {
          en: 'en-GB',
          cn: 'zh-CN',
          tc: 'zh-HK',
          jap: 'ja-JP',
          ko: 'ko'
        }
        return vm.$d(util.dateArr(date), 'short', langMap[lang])
      } else {
        return date
      }
    }

  },
  methods: {
    formatMoney
  },
  computed:{
    skin() {
      return this.$store.state.gaData.skinCode
    }
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
